<template>
  <div>
    <el-dialog
      :style="isMB?'margin-top: -13vh !important;':'margin-top: 30vh !important;'"
      title="设置通话时长上限"
      :visible.sync="dialogVisible"
      width="280px"
      :before-close="handleClose"
    >
      <el-row>
        <el-col :span="5">
            <span style="vertical-align:-5px;">分钟</span>
        </el-col>
        <el-col :span="19">
          <el-input size="mini" v-model="CallLimit" type="number" placeholder="请填写"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submit">保 存</el-button>
        <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      CallLimit: null,
      dialogVisible: false,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    open(id) {
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
      this.CallLimit = null
    },
    submit() {
      if(!(this.CallLimit>0&&this.CallLimit%1==0)) {
        this.$message.error("请填写大于0的整数")
        return false
      }
      this.dialogVisible = false
      this.$emit("setLimit",this.CallLimit)
    },
    handleClose() {}
  }
};
</script>

<style>
</style>